export default __webpack_public_path__ + "static/media/soldiers.e2343712.svg";